export const getCompanyName = (savedJob) => {
    return savedJob?.jobDetails?.company || savedJob?.job?.company || "Company Name"
}